module.exports = __webpack_public_path__ + "static/media/runway_mobile.422c4e6f.jpg";